/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { InjectionToken } from '@angular/core'

export const LOCALISATION_BASE_URL = new InjectionToken<string>('localisationBasePath')
export const LOCALISATION_VERSION = new InjectionToken<string>('localisationVersion')

export const BackendRoutes = {
  FORM__LOCALE_SCHEMA: 'schemas/:version/:type/:country/:locale.json',
  FORM__SCHEMA: 'schemas/:version/:type/:country.json',
  FORM__FINAL_SCHEMA: 'schemas/:version/:type/:country/:locale.json',
  FORM__LAYOUT: 'layouts/:version/:type/:country.json',
  FORM__TRANSLATIONS: 'translations/:version/:project/:locale.json',

  CONFIG__BASE: 'configuration/:version/:stage/:country/:locale.json',
  COUNTRY_LANGUAGE__TRANSLATIONS: 'country-language-translations/:version/:locale.json',
  COUNTRY__TRANSLATIONS: 'country-translations/:version/:locale.json',

  FOOTER__PORSCHEWEB: 'footers/:version/:stage/FOOTER_PORSCHEWEB/:locale.json',
  FOOTER__MYPORSCHE: 'footers/:version/:stage/FOOTER_MYPORSCHE/:locale.json',
  FOOTER__LEGAL: 'footers/:version/:stage/FOOTER_LEGAL/:locale.json',
}
